/* src/app/modules/members/search-member/search-member.component.css */
row {
  width: 100%;
}
/*# sourceMappingURL=search-member.component.css.map */
